import React from 'react';
import '../styles/hero.css';
import '../styles/base.css';
import profilePic from '../assets/profile2.jpg'; // update with your actual image path

const Hero = () => (
  <div className="hero-section">
  <div className="hero-container">
    <div className="hero-text">
      <h1>Hello, my name is</h1>
      <div className="styled-name">Karsten Hedrick</div>
    </div>
    <div className="hero-image">
      <img src={profilePic} alt="KARSTEN HEDRICK" />
    </div>
  </div>
</div>

);

export default Hero;
